import React, { Component } from 'react';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import MainBlock from '../../../components/blocks/MainBlock';
import YoutubeVideoImage from "../../../components/YoutubeVideoImage";

export default class Blocks extends Component {

    constructor(props) {
        super(props);

        this.blocks = [
            {
                title: "We design communication",
                linkTarget: "",
                icon: "screenshot",
                text: (
                    <p>Are innovation and organisational change key priorities for the Board? TROI is your strategic partner to design the right program and bring it to live.</p>
                ),
                video: (
                      <YoutubeVideoImage videoId="Q40BbxXJXNE" />
                )
            },
            {
                title: "We produce video content",
                linkTarget: "",
                icon: "film",
                text: (
                    <p>Do you want a company who excels at creating world-class videos? TROI delivers full-service video production with high production values, as witnessed through our client list.</p>
                ),
                video: (
                    <YoutubeVideoImage videoId="3nWiQGbBl3Y" />
                )
            },
            {
                title: "We orchestrate technology",
                linkTarget: "",
                icon: "dashboard",
                text: (
                    <p>Are you reaching your target audience? TROI's development team orchestrates technology to enable digital knowledge transfer and social collaboration.</p>
                ),
                video: (
                    <YoutubeVideoImage videoId="NJGQ6IrBqxg" />
                )
            }
        ];
    }

    render() {
        return (
            <BlockWrapper>
                {this.blocks.map((blockData, index) => (
                    <MainBlock key={index}
                        title={blockData.title}
                        linkTarget={blockData.linkTarget}
                        icon={blockData.icon}
                        text={blockData.text}
                        video={blockData.video}>
                    </MainBlock>
                ))}
            </BlockWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/parts/home/Blocks.js